export const jobOpenings = [
  {
    id: 1,
    title: "Sales Development Representative",
    description:
      "As an SDR, you'll be the first point of contact between prospective clients and our sales team.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "As an SDR, you’ll be the first point of contact between prospective clients and our sales team. You’ll play a key role in building a sales pipeline by identifying, connecting with, and qualifying leads through outreach efforts such as cold calls, emails, and LinkedIn messaging. Candidates with extraordinary speaking skills are encouraged to Apply.",
      responsibilities: [
        "Prospect and identify potential customers through outbound strategies (cold calling, emailing, social selling).",
        "Qualify inbound and outbound leads to determine fit and potential.",
        "Schedule meetings and demos for Account Executives.",
        "Maintain accurate records of all interactions in the CRM (e.g., HubSpot, Salesforce).",
        "Collaborate with marketing and sales teams to refine messaging and outreach strategies.",
        "Continuously improve outreach tactics based on performance metrics and feedback.",
        "Meet or exceed monthly quotas for outreach, meetings booked, and qualified leads.",
      ],
      qualifications: [
        "Bachelor’s degree preferably in Business, Marketing, Communications, IT, or Public Relations",
        "1–2 years of experience in a sales, business development, or customer-facing role.",
        "Strong communication and interpersonal skills.",
        "High level of motivation, self-discipline, and a positive attitude.",
        "Comfortable with outbound calls, objection handling, and rejection.",
        "Familiarity with CRM tools (e.g., Salesforce, HubSpot) is a plus.",
        "Professional with the ability to judge and make decisions in accordance with the space of time and room’s energy.",
      ],
      benefits: [
        "Competitive base salary + commission",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
  {
    id: 2,
    title: "Accountant",
    description:
      "Assist with daily accounting operations including accounts payable, accounts receivable, and bank reconciliations.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview: "We are looking for a detail-oriented Accountant to join our team.",
      responsibilities: [
        "Assist with daily accounting operations including accounts payable, accounts receivable, and bank reconciliations.",
        "Record and maintain accurate financial transactions in the general ledger.",
        "Prepare and process invoices, expense reports, and payment requests.",
        "Support monthly, quarterly, and year-end close processes.",
        "Assist with payroll processing and benefits reconciliation (as needed).",
        "Monitor and track fixed assets and inventory (if applicable).",
        "Ensure compliance with company policies and relevant accounting regulations.",
        "Provide support during audits and tax preparation.",
        "Maintain well-organized physical and digital financial records.",
        "Collaborate with internal departments to resolve discrepancies and improve financial processes.",
      ],
      qualifications: [
        "Bachelor’s degree in Accounting, Finance, or a related field.",
        "1–2 years of experience in accounting or bookkeeping (internships included).",
        "Proficient in Microsoft Excel and accounting software (e.g., QuickBooks, NetSuite, Xero).",
        "Strong attention to detail and organizational skills.",
        "Ability to work independently and in a team environment.",
        "Excellent communication and time management skills.",
      ],
      preferredQualifications: [
        "Experience with ERP systems or cloud-based accounting platforms.",
        "Knowledge of GAAP and financial reporting principles.",
      ],
      benefits: [
        "Competitive base salary + commission",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
  {
    id: 3,
    title: "Account Executive",
    description:
      "The Account Executive is responsible for driving new business opportunities, managing the full sales cycle from prospecting to closing, and building strong client relationships.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "The Account Executive is responsible for driving new business opportunities, managing the full sales cycle from prospecting to closing, and building strong client relationships. You’ll work closely with SDRs, marketing, and customer success to deliver value-driven solutions to prospective clients.",
      responsibilities: [
        "Own and manage a pipeline of qualified leads from discovery to close",
        "Conduct consultative sales calls, product demos, and negotiations",
        "Understand client pain points and clearly articulate how our solutions can solve them",
        "Collaborate with SDRs to ensure smooth handoff and outreach alignment",
        "Accurately forecast revenue and maintain CRM hygiene (e.g., Salesforce, HubSpot)",
        "Consistently meet or exceed monthly and quarterly sales quotas",
        "Stay up to date on industry trends, competitors, and product knowledge",
        "Represent the company at trade shows, networking events, and client meetings (if applicable)",
      ],
      qualifications: [
        "1-2+ years of B2B sales experience (SaaS or tech experience is a plus)",
        "Proven track record of meeting or exceeding sales targets",
        "Strong communication, negotiation, and presentation skills",
        "High level of business acumen and consultative selling ability",
        "Self-motivated with excellent time management and organizational skills",
        "Experience with CRM software (e.g., Salesforce, HubSpot, Pipedrive)",
        "Bachelor’s degree in Business, Accounting or any other related field. (Master’s degree to be given preference (Candidates not having Master’s degree can bring Equivalent experience in lieu of such)",
      ],
      benefits: [
        "Competitive base salary + commission",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
  // {
  //   id: 4,
  //   title: "Accounting Associate",
  //   description:
  //     "As an Accounting Associate you will play a crucial role in ensuring the financial health and compliance of the client.",
  //   mode: "Remote",
  //   location: "Pakistan",
  //   type: "Full-time",
  //   details: {
  //     overview:
  //       "As an Accounting Associate you will play a crucial role in ensuring the financial health and compliance of the client. Responsible for executing various tasks, from bookkeeping and reconciliation to financial reporting. This role offers an opportunity to contribute to the success of diverse businesses, collaborate with a dynamic team, and grow in a challenging and rewarding environment.",
  //     responsibilities: [
  //       "Bookkeeping and Record Maintenance - Perform day-to-day bookkeeping tasks using QuickBooks, including recording financial transactions, and maintaining accurate ledgers.",
  //       "Bank Reconciliation – Reconcile bank statements and financial data while identifying and resolving discrepancies.",
  //       "Compliance and Process Improvements – Ensure compliance with relevant regulations and deadlines while identifying opportunities for process improvement, automation, and efficiency enhancements.",
  //       "Budget Monitoring – Support in monitoring and analyzing budget performance, providing insights and recommendations.",
  //       "Client communication – Collaborate with clients to gather necessary financial information, address queries, and ensure a smooth client experience.",
  //     ],
  //     qualifications: [
  //       "Qualification: A 4-Year Bachelor's degree, preferably in Accounting & Finance.",
  //       "Prior knowledge/experience of QuickBooks.",
  //       "Exposure to Debit/Credit (double entries).",
  //       "Prior Accounting Firm Experience",
  //       "Someone who has a strong willingness to learn.",
  //       "Strong spoken and written English communication skills.",
  //       "Possess leadership skills demonstrated through extra-curricular activities.",
  //       "Strong collaboration skills.",
  //     ],
  //     benefits: [
  //       "Competitive base salary + commission",
  //       "Health Insurance",
  //       "Career growth opportunities",
  //       "Fun, collaborative, and respectful team environment",
  //       "Remote flexibility and modern tools for success",
  //       "Performance-based incentives and recognition",
  //       "Company Dinners and Tours",
  //     ],
  //   },
  // },
  // {
  //   id: 5,
  //   title: "Accountant",
  //   description:
  //     "Compile balance sheets, P&L, and cash flow statements, ensuring compliance with ATO regulations and Australian Standards.",
  //   mode: "Remote",
  //   location: "Pakistan",
  //   type: "Full-time",
  //   details: {
  //     overview:
  //       "This role requires a dedicated Accountant with strong financial reporting and taxation knowledge.",
  //     responsibilities: [
  //       "Compile balance sheets, P&L, and cash flow statements",
  //       "Compliance with the ATO regulations, tax filings, and planning",
  //       "Assist with audit preparations, ensure accuracy and compliance with Australian Standards",
  //       "Analyze financial trends, conduct cost-benefit studies, and advise on enhancing profitability and efficiency",
  //       "Stay current with financial regulations and standards to ensure compliance in financial reporting",
  //       "Recording and reconciliation of financial transactions, including invoices, receipts, payments, and expenses",
  //       "Regularly reconcile bank accounts for accurate financial data",
  //       "Prepare and file Business Activity Statements, ensuring GST compliance under senior accountant supervision",
  //     ],
  //     qualifications: [
  //       "Qualification: A 4-Year Bachelor's degree, preferably in Accounting & Finance, CA/ACCA Associate",
  //       "Prior knowledge/experience of QuickBooks.",
  //       "Exposure to Debit/Credit (double entries).",
  //       "Prior Accounting Firm Experience",
  //       "Someone who has a strong willingness to learn.",
  //       "Strong spoken and written English communication skills.",
  //       "Possess leadership skills demonstrated through extra-curricular activities.",
  //       "Strong collaboration skills.",
  //     ],
  //     preferredQualifications: [ // Renamed 'aboutYou' to 'preferredQualifications' for consistency
  //       "Bachelor's degree in Accounting or related field",
  //       "CPA, CA, or ACCA certification",
  //       "2-5 years of accounting/audit experience including financial statements and taxation",
  //       "Advanced understanding of accounting systems and spreadsheets",
  //       "Advanced English Proficiency to effectively engage with a global team and clients",
  //       "Knowledge of Accounting regulations and procedures.",
  //       "Australian experience is highly desirable.",
  //     ],
  //     benefits: [
  //       "Competitive base salary",
  //       "Health Insurance",
  //       "Career growth opportunities",
  //       "Fun, collaborative, and respectful team environment",
  //       "Remote flexibility and modern tools for success",
  //       "Performance-based incentives and recognition",
  //       "Company Dinners and Tours",
  //     ],
  //   },
  // },
  {
    id: 6,
    title: "Contact Centre Representative",
    description:
      "Be the first line of support for our customers, resolving inquiries and ensuring a positive experience.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "As a Contact Centre Representative, you'll be the voice our customers hear first. You'll answer incoming calls, emails, and chats with warmth, clarity, and professionalism, resolving inquiries and guiding customers with accurate information.",
      responsibilities: [
        "Be the First Line of Support: Answer incoming calls, emails, and chats with warmth, clarity, and professionalism.",
        "Resolve with Confidence: Handle inquiries, resolve issues, and guide customers with accurate information about products, services, orders, or policies.",
        "Own the Customer Experience: Understand customer needs, de-escalate concerns calmly, and ensure each interaction leaves them feeling supported and valued.",
        "Keep Records Clean and Clear: Log all interactions accurately in our systems—notes, follow-ups, resolutions—so that no detail is missed.",
        "Collaborate Across Teams: Work closely with internal departments to resolve more complex customer needs and share feedback to improve the overall experience.",
        "Stay In the Know: Keep up-to-date with product updates, process changes, and tools so you can always provide the most accurate support.",
      ],
      qualifications: [
        "Excellent communication skills—clear, friendly, and confident over the phone and in writing.",
        "Patience and empathy—especially when customers are stressed or upset.",
        "Quick thinker and problem solver—able to work through issues efficiently and effectively.",
        "Strong attention to detail with accurate data entry and documentation.",
        "Tech-comfortable—familiar with CRM tools or willing to learn.",
        "1-2 years + experience in a contact Centre or customer service environment is a plus, but not required.",
      ],
      benefits: [
        "Competitive base salary",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
  {
    id: 7,
    title: "Legal Associate",
    description:
      "Provide purposeful support to legal professionals by drafting documents, conducting research, and managing client communications.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "This role requires a high level of attention to detail, superb organizational skills, and a deep understanding of legal terminology and court procedures. The ideal candidate is someone who can manage a fast-paced environment, effectively communicate with various stakeholders, and provide purposeful support to legal professionals.",
      responsibilities: [
        "Answer calls and schedule meetings with attorney",
        "Draft and prepare legal documents related to Estate Planning, Probate, and Guardianship.",
        "Conduct legal research and gather relevant information.",
        "Assist attorney with case preparation and management.",
        "Maintain and organize client files and records.",
        "Communicate with clients and other parties as needed.",
        "Schedule meetings with clients, communicate with clients to keep matters moving toward conclusion",
        "Draft pleadings and estate documents to attorney specifications.",
        "Keep, manage, and share timelines of all matters using firm’s CRM.",
        "Present all drafts to the attorney for review.",
        "All payments, billing, and e-filing will be managed by the attorney.",
        "Confidentiality and proprietary agreement to be signed.",
      ],
      qualifications: [
        "Bachelors degree in Arts. Preferably Political Science, Law, or IR.",
        "Proven experience as a Paralegal in Estate Planning, Probate, and Guardianship is preferred but willing to train a viable candidate.",
        "Strong knowledge of relevant laws and legal procedures.",
        "Excellent drafting and writing skills.",
        "Ability to work independently and manage multiple tasks.",
        "Strong organizational and communication skills.",
        "Must have own PC with Microsoft Word and internet access.",
      ],
      benefits: [ // Renamed 'whatYouNeedToSucceed' to 'benefits' for consistency
        "Competitive base salary",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance- based incentives and recognition",
        "Company Dinners and Tours",],
    },
  },
  {
    id: 8,
    title: "Client Relations Associate - Insurance",
    description:
      "Foster client relationships by delivering timely and precise communication to US-based customers via verbal and written channels.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "As a Client Relations Associate for Insurance, you will be crucial in maintaining strong client relationships and ensuring compliance with regulatory standards.",
      responsibilities: [
        "Foster client relationships by delivering timely and precise communication to US-based customers via verbal and written channels",
        "Provide prompt resolution for quotes, claims, e-signatures, billing, and other policy requests",
        "Liaise with external entities to maintain an exceptional customer experience",
        "Maintain customer files and record any transactions with customers in the CRM",
        "Proactively identify and address customer needs to enhance overall satisfaction",
        "Ensure compliance with Errors & Omissions regulatory standards while executing all tasks",
      ],
      qualifications: [ // Renamed 'requirements' to 'qualifications' for consistency
        "Minimum bachelor’s degree in Business, Economics or Humanities",
        "At least 2 year of Commercial lines, Personal Lines, Customer Service and Sales",
        "Proficiency in digital tools (Google Workspace, MS Office, Zoom)",
        "Minimum Internet speed of 40 MBPS fiber connection and a power back up",
      ],
      benefits: [ // Added a placeholder 'benefits' array for consistency
        "Competitive base salary",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
  {
    id: 9,
    title: "Client Relation Associate - Health",
    description:
      "Communicate with patients with empathy, handle patient intake, schedule appointments, and manage health insurance claims.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "As a Client Relations Associate for Health, you'll be a key point of contact for patients, ensuring smooth operations from scheduling to insurance claims.",
      responsibilities: [
        "Communicate with patients with empathy via calls and text, providing prompt resolutions to queries",
        "Handle patient intake and schedule appointments with meticulous detail.",
        "Accurately maintain electronic health records (EHR)",
        "Verify benefits, obtain prior authorizations, and manage health insurance claims via calls and web portals",
        "Coordinate with pharmacies and labs to assist with prescription refills and lab orders",
        "Ensure compliance with the Health Insurance Portability and Accountability Act (HIPAA) while executing all tasks",
      ],
      qualifications: [ // Renamed 'requirements' to 'qualifications' for consistency
        "MBBS, BDS, or any Public Health Degree",
        "At least 2 years of work experience as a medical professional, Medical Billing experience, or Virtual Assistant",
        "Proficiency in Google Workspace, MS Office, and Zoom.",
        "Minimum Internet speed of 40 MBPS fiber connection and 4G portable internet as a backup",
        "Familiarity with medical terminology and patient care protocols.",
      ],
      benefits: [ // Added a placeholder 'benefits' array for consistency
        "Competitive base salary",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
  {
    id: 10,
    title: "Client Relations Associate (Dental)",
    description:
      "Manage dental management systems, process insurance claims, coordinate appointments, and provide exceptional customer service.",
    mode: "Remote",
    location: "Pakistan",
    type: "Full-time",
    details: {
      overview:
        "As a Client Relations Associate for Dental, you'll be instrumental in managing dental operations, ensuring seamless patient care and administrative efficiency.",
      responsibilities: [ // Renamed 'keyResponsibilities' to 'responsibilities' for consistency
        "DMS Management: Managing dental management systems such as Dentrix Ascend, iTero, EagleSoft, and Open Dental. Tasks include updating records, vetting for accuracy, data entry, maintaining patient notes, and ensuring documentation is up-to-date.",
        "Insurance Claims Processing: Handling patient insurance verification, communicating with insurance carriers, gathering benefits and history details, assessing coverage coverage amounts, and managing ADA/CDT codes. This includes processing claims efficiently to streamline patient care.",
        "Rescheduling and Scheduling: Coordinating inbound appointments, managing doctor calendars, supporting rescheduling efforts, following up on appointments, and attaching relevant patient notes with scheduled visits. This also includes organizing Bitewing Radiographs efficiently.",
        "Customer Service Support: Providing exceptional support by handling patient queries, addressing rescheduling or emergency situations, managing inbound and outbound phone calls, verifying patient details, and ensuring seamless insurance verification processes.",
        "Eliminate administrative overload: Supporting administrative tasks such as invoicing, billing maintenance, treatment planning, collecting and recording patient information, acting as a liaison for communication, following up on tasks, assigning responsibilities, ordering supplies, and reviewing timesheets for accuracy.",
        "Uphold patient confidentiality: Follow strict data security protocols, safeguarding patients' privacy at every turn.",
      ],
      qualifications: [ // Renamed 'requirements' to 'qualifications' for consistency
        "MBBS, BDS, or any Public Health Degree",
        "At least 2 years of work experience as a Medical/Dental professional, Medical Billing experience, or Virtual Assistant",
        "Proficiency in Google Workspace, MS Office, and Zoom.",
        "Proficient in CRM usage.",
        "Minimum Internet speed of 40 MBPS fiber connection and 4G portable internet as a backup",
        "Familiarity with medical terminology and patient care protocols.",
      ],
      benefits: [ // Added a placeholder 'benefits' array for consistency
        "Competitive base salary",
        "Health Insurance",
        "Career growth opportunities",
        "Fun, collaborative, and respectful team environment",
        "Remote flexibility and modern tools for success",
        "Performance-based incentives and recognition",
        "Company Dinners and Tours",
      ],
    },
  },
];